import React, { Component } from 'react';
import Helmet from 'react-helmet';
import Header from '../../common/Header';
import SupportNav from '../SupportNav';
import Breadcrumb from '../../common/Breadcrumb';
import BreadcrumbItem from '../../common/BreadcrumbItem';
import LostKeyComboCallouts from './LostKeyComboCallouts';

class LostKeyCombo extends Component {
	render() {
		return (
			<div>
				<Helmet>
					<title>Country Select | Lost Key or Combination | SentrySafe</title>
					<meta name="description" content="Select country for requesting a key replacement and a combination recovery for your SentrySafe product with our quick-and-easy replacement and recovery process." />
				</Helmet>

				<Breadcrumb>
					<BreadcrumbItem label="Support" path="/support" />
					<BreadcrumbItem label="Lost Key or Combination"/>
				</Breadcrumb>

				<SupportNav />

				<Header
					title="Lost Your Key or Combination?"
					description="Select your current country to view replacement options."
				/>
				<LostKeyComboCallouts />
			</div>
		);
	}
}

export default LostKeyCombo;


// WEBPACK FOOTER //
// ./src/pages/support/lostKeyCombo/LostKeyCombo.js